import { fmtTime } from "@/api";
import { directionLabel, sourceLabel } from "@/i18n";

const waitingStatus = (value) => ({
  WAIT_FOR_REENTRY: "Public watcher 监控中",
}[value] || value || "—");

const waitedDuration = (value) => {
  const started = new Date(value).getTime();
  if (!Number.isFinite(started)) return "—";
  const totalMinutes = Math.max(0, Math.floor((Date.now() - started) / 60000));
  return `${Math.floor(totalMinutes / 60)}h ${totalMinutes % 60}m`;
};

const relationshipText = (value) => ({
  FAVORABLE: "有利价格", ADVERSE: "不利价格", AT_REFERENCE: "等于参考价",
}[value] || value || "—");

const waitReasonText = (value) => ({
  REFERENCE_ENTRY_ADVERSE_DEVIATION_WAITING: "不利价格偏差超过容忍度",
  SL_PROXIMITY_WAITING: "距离止损过近",
  RR_TO_TP1_BELOW_MINIMUM_WAITING: "当前 RR 低于 0.5",
  STRICT_LIMIT_WAITING: "等待明确限价条件",
  OUTSIDE_FIXED_ENTRY_ZONE_WAITING: "当前价格在固定区间外",
  OUTSIDE_DYNAMIC_ENTRY_ZONE_WAITING: "当前价格在动态区间外",
}[value] || value || "—");

export const WaitingEntryLedger = ({ rows }) => (
  <section className="ledger-section waiting-ledger" data-testid="waiting-entry-section">
    <div className="section-heading">
      <div><p className="eyebrow">不追价 · 安全重入</p><h2>等待入场</h2></div>
      <b data-testid="waiting-entry-count">{rows.length}</b>
    </div>
    <div className="table-frame waiting-table-frame"><table data-testid="waiting-entry-table"><thead><tr>
      <th data-testid="waiting-header-environment">Environment</th><th data-testid="waiting-header-source">号机</th><th data-testid="waiting-header-symbol">Symbol</th><th data-testid="waiting-header-direction">方向</th><th data-testid="waiting-header-entry">KOL Entry</th>
      <th data-testid="waiting-header-intent">Entry Intent</th><th data-testid="waiting-header-current-price">当前价格</th><th data-testid="waiting-header-deviation">当前偏差</th><th data-testid="waiting-header-relationship">价格判断</th>
      <th data-testid="waiting-header-condition">执行条件</th><th data-testid="waiting-header-stop">SL</th><th data-testid="waiting-header-tp1">TP1</th><th data-testid="waiting-header-reason">WAIT 原因</th>
      <th data-testid="waiting-header-start">等待开始</th><th data-testid="waiting-header-duration">已等待时长</th><th data-testid="waiting-header-status">当前状态</th>
    </tr></thead><tbody>{rows.map((row) => <tr key={row.trade_id} data-testid={`waiting-entry-row-${row.trade_id}`}>
      <td data-testid={`waiting-environment-${row.trade_id}`}>{row.environment || "DEMO"}</td><td data-testid={`waiting-source-${row.trade_id}`}>{sourceLabel(row.source, row.source_display)}</td>
      <td className="mono" data-testid={`waiting-symbol-${row.trade_id}`}>{row.symbol || "—"}</td>
      <td data-testid={`waiting-direction-${row.trade_id}`}>{directionLabel(row.direction)}</td>
      <td className="mono" data-testid={`waiting-kol-entry-${row.trade_id}`}>{row.kol_entry_raw || row.kol_entry_price || row.entry_range?.join(" - ") || "—"}</td>
      <td data-testid={`waiting-intent-${row.trade_id}`}>{row.ai_entry_intent || row.entry_intent || "—"}</td>
      <td className="mono" data-testid={`waiting-current-price-${row.trade_id}`}>{row.current_execution_price || "—"}</td>
      <td className="mono" data-testid={`waiting-deviation-${row.trade_id}`}>{row.entry_deviation_pct ? `${row.entry_deviation_pct}%` : "—"}</td>
      <td data-testid={`waiting-relationship-${row.trade_id}`}>{relationshipText(row.price_relationship)}</td>
      <td className="mono" data-testid={`waiting-zone-${row.trade_id}`}>{row.reentry_zone_low && row.reentry_zone_high ? `${row.reentry_zone_low} – ${row.reentry_zone_high}` : row.reentry_zone_high ? `≤ ${row.reentry_zone_high}` : row.reentry_zone_low ? `≥ ${row.reentry_zone_low}` : "安全条件恢复后重评估"}</td>
      <td className="mono" data-testid={`waiting-stop-${row.trade_id}`}>{row.stop_loss || "—"}</td>
      <td className="mono" data-testid={`waiting-tp1-${row.trade_id}`}>{row.take_profits?.[0] || "—"}</td>
      <td data-testid={`waiting-reason-${row.trade_id}`}>{waitReasonText(row.wait_reason || row.reason)}</td>
      <td className="mono" data-testid={`waiting-start-${row.trade_id}`}>{fmtTime(row.entry_wait_started_at)}</td>
      <td className="mono" data-testid={`waiting-duration-${row.trade_id}`}>{waitedDuration(row.entry_wait_started_at)}</td>
      <td><span className="execution-state waiting" data-testid={`waiting-status-${row.trade_id}`}>{waitingStatus(row.status)}</span></td>
    </tr>)}</tbody></table></div>
    {!rows.length && <p className="empty-state" data-testid="waiting-entry-empty">当前没有等待重入的信号。</p>}
  </section>
);